import { COLORS, FONTS } from '../../../constants';

const styles = () => ({
  fieldContain: {
    paddingTop: '12px',
    // caretColor: COLORS.WHITE,
  },
  buttonContain: {
    paddingTop: '20px',
    display: 'flex',
  },
  buttonContain_back: {
    flex: 1,
    paddingRight: '10px',
  },
  buttonContain_submit: {
    flex: 4,
  },
  mainButton: {
    height: '61px',
    color: COLORS.WHITE,
    fontWeight: 600,
    fontSize: '18px',
  },
  forgotPwLinkContain: {
    paddingTop: '9px',
    cursor: 'pointer',
    color: COLORS.GREY_DARK,
  },
  troubleLoginText: {
    cursor: 'pointer',
    color: 'black',
  },
  hidden: {
    visibility: 'hidden',
  },
  buttonProgress: {
    color: 'green',
    position: 'absolute',
  },
  submitFailedContain: {
    paddingTop: '10px',
    // display: 'flex',
  },
  submitFailed_message: {
    display: 'inline-block',
  },
  submitFailed_link: {
    display: 'inline-block',
    paddingLeft: '10px',
  },
  number: {
    color: '#00672d',
    fontWeight: 600,
  },
  tipIconContain: {
    display: 'flex',
    paddingTop: '20px',
  },
  tipIcon: {
    paddingRight: '18px',
  },
  placeText: {
    color: COLORS.GREEN_0,
    fontSize: '20px',
    fontWeight: 700,
    fontFamily: FONTS.PRIMARY,
  },
  downloadButtonText: {
    color: COLORS.WHITE,
    padding: '3px',
  },
  downloadButton: {
    // borderColor: COLORS.WHITE,
    backgroundColor: COLORS.GREEN,
    '&:hover': {
      fill: COLORS.GREEN,
    },
    borderWidth: '2px',
    borderRadius: 0,
    marginTop: 30,
    height: 49,
    width: '100%',
    '& > span': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  'MuiButtonBase-root': {
    '&:hover': {
      fill: COLORS.GREEN,
    },
  },
});

export default styles;
